module.exports = __webpack_public_path__ + "static/media/dispatch_records_active_es.cc285831.svg";